import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {DepotForm} from './components/DepotForm'
import {ModeleDepot} from '../../../components/Models'

type LocationState = {
  data: ModeleDepot | undefined | null
}

const DepotPage = () => {
  let {depotId} = useParams()

  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {depotId === undefined ? 'Créer' : 'Modifier'} un dépôt
            </h3>
          </div>
        </div>

        <div>
          <DepotForm id={depotId} data={state ? state.data : null} />
        </div>
      </div>
    </>
  )
}

export {DepotPage}
